import React from 'react';
import { useFormContext } from 'react-hook-form';

import SCampaignInfo from 'Components/structural/SCampaignInfo/SCampaignInfo';
import { withCampaignHoc } from 'Pages/Activity/Campaign/hoc/withCampaign';
import { CampaignFormValues } from 'Pages/Activity/Campaign/saveCampaign.hook';

import { RandomConfigurationSection } from './components/RandomConfiguration';
import { CampaignSessionList } from './components/CampaignSessionList';
import styles from './ContentDays.style';

export const ContentDays = withCampaignHoc(({ campaign }) => {
  const { watch } = useFormContext<CampaignFormValues>();

  const random = watch('mode') === 'random';

  const active = ['upcoming', 'live', 'finished'].includes(campaign.status);
  const contentCount = watch('contents')?.length || watch('orderedSessions')?.flat().length || 0;
  const sessionsCount = watch('nbSessions') || watch('orderedSessions')?.length || 0;

  return (
    <div>
      <SCampaignInfo
        active={active}
        contentCount={contentCount}
        sessionCount={sessionsCount}
        extraDays={watch('type') === 'flexible' ? watch('extraDays') || 0 : 0}
        startDate={watch('launchDate')}
        endDate={watch('endDate')}
        stickyContainerStyle={styles.campaignHeader}
        stickyStyle={styles.stickySCampaignInfo}
        style={styles.sCampaignInfo}
      />
      <div style={styles.container}>
        {random && <RandomConfigurationSection campaignStatus={campaign.status} />}
        <CampaignSessionList />
      </div>
    </div>
  );
});
